<template>
  <div class="face-authorization-config">
    <breadcrumb :breadcrumb="breadcrumb" />
	<text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="form-line">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">公安身份验证：</span>
      </div>
      <el-switch v-model="formData.faceVerify" active-text="是" :disabled="!modifyState" inactive-text="否"></el-switch>
    </div>

    <div class="form-line" v-if="formData.faceVerify">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">验证模式：</span>
      </div>
      <el-select v-model="formData.payPattern" size="small" style="width: 280px" :disabled="!modifyState">
        <el-option v-for="item in payPatternList" :key="item.code"
                   :label="item.name" :value="item.code">
        </el-option>
      </el-select>
    </div>

    <div class="form-line" v-if="formData.faceVerify && formData.payPattern === '2'">
      <div class="textBox" style="margin-right: 20px;">
        <span class="line-text">剩余次数：</span>
      </div>
      <el-input v-model="formData.surplusCount" size="small" style="width: 280px" disabled/>
    </div>

    <div class="form-btn-box" v-if="!modifyState" style="display: flex;justify-content: center;">
      <button-confirm @confirm="modify" value="修改"  />
    </div>
    <div class="form-btn-box" v-if="modifyState">
      <button-confirm @confirm="confirm" />
      <button-cancel @cancel="cancel" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonConfirm from "../../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../../components/Button/ButtonCancel";
import TextTitle from '../../../../components/Text/TextTitle'
import {errorHandler} from '../../../../utils/errorHandler'
import {nError, nSuccess} from '../../../../utils/notice'
import {api} from '../../../api/ConfigManagement'
export default {
  name: 'FaceAuthorizationConfig',
  components: {Breadcrumb, ButtonCancel, ButtonConfirm, TextTitle},
  data () {
    return {
      breadcrumb: [
        {value: "资源中心", name: "yq-information"},
        {value: "配置管理"}
      ],
	    mainTitle: '人脸授权配置',
      subheading: '',
      payPatternList: [
        {code: '1', name: '先付费后使用'},
        {code: '2', name: '先使用后付费'},
      ],
      formData: {
        faceVerify: false,
        payPattern: '',
		    surplusCount: ''
      },
      modifyState: false
    }
  },
  created () {
	  this.getPersonPicConfig()
  },
  mounted() {
  },
  methods: {
    // 获取配置信息
    getPersonPicConfig () {
      this.$axios.get(api.getPersonPicConfig, {})
      .then(res => {
          this.formData = res.data.data
      })
      .catch(errorHandler('获取信息失败'))
    },
    // 点击修改
    modify() {
      this.modifyState = true;
    },
    // 取消修改
    cancel() {
      this.modifyState = false;
      this.getPersonPicConfig();
    },
    confirm () {
      this.$axios.post(api.updatePersonPicConfig, this.formData)
        .then(res => {
             nSuccess('修改成功')
           this.modifyState = false;
           this.getPersonPicConfig()
        })
        .catch(errorHandler('修改失败'))
    }
  },
}
</script>

<style scoped lang="less">
.face-authorization-config {

}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/FaceAuthorizationConfig/FaceAuthorizationConfig.vue